// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getContactAuditEvents } from '@/audit/api/get-contact-audit-events';
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { Stack, Typography } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';

interface Props {
  contactKey: string;
}

export function ContactAuditList(props: Props) {
  const { data } = useSuspenseQuery({
    queryKey: ['contact', props.contactKey, 'audit'],
    queryFn: () => getContactAuditEvents(props.contactKey),
    retry: false,
  });

  if (data.events.length === 0) {
    return (
      <Typography color="text.secondary" textAlign="center">
        No audit events for this contact
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {data.events.map((event) => (
        <AuditEventListItem key={event.id} event={event} />
      ))}
    </Stack>
  );
}
